













































































import {Vue, Component, VModel} from 'vue-property-decorator';
import RightSideBar from "@/components/payroll/business/services/RightSideBar.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import PortalAddress from "@/components/profile/branches/PortalAddress.vue";
import {
	CreateInvoicePayload,
	InvoiceContact,
	SelectableServiceLogDTO,
	ServiceRecordDTO
} from "@/components/payroll/business/services/ServiceDTO";
import RefContactSliderSelector from "@/components/payroll/business/services/contact/RefContactSliderSelector.vue";
import ServiceView from "@/components/payroll/business/services/ServiceView.vue";
import ServiceLogSliderSelector from "@/components/payroll/business/services/service/ServiceLogSliderSelector.vue";
import ServiceLogView from "@/components/payroll/business/services/ServiceLogView.vue";
import SelectableServiceLog from "@/components/payroll/business/services/service/SelectableServiceLog.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import SelectOption from "@/components/common/SelectOption";
import ServiceInvoiceOrchestrator from "@/services/ServiceInvoiceOrchestrator";
import Application from "@/state/Application";
import {processError} from "@/utils/ComponentUtils";
import Notifications from "@/state/Notifications";
import PortalDate from "@/components/common/PortalDate.vue";

@Component({
	components: {
		PortalDate,
		PortalSelect,
		SelectableServiceLog,
		ServiceLogView,
		ServiceLogSliderSelector,
		ServiceView, RefContactSliderSelector, PortalAddress, PortalInput, RightSideBar}
})
export default class BillCreationSlider extends Vue {

	@VModel({type: Boolean, default: false})
	private model!: boolean

	private req = new CreateInvoicePayload()

	private currentProfile: InvoiceContact = new InvoiceContact(
		{
			email: "",
			id: this.$wss.getCurrent.id,
			name: this.$wss.getCurrent.name,
			userId: this.$wss.getCurrent.userId,
			refUserId: this.$wss.getCurrent.userId
		}
	);

	get showMyProfile(): boolean {
		return this.selectedPayer?.id != this.currentProfile.id && this.selectedPayee?.id != this.currentProfile.id
	}

	private selectedPayee: InvoiceContact | null = null;
	private selectedPayer: InvoiceContact | null = new InvoiceContact(
		{
				userId: this.$wss.getCurrent.userId,
				refUserId: this.$wss.getCurrent.userId,
				name: this.$wss.getCurrent.name,
				email: "",
				id: this.$wss.getCurrent.id
			}
		);
	private selectedServices: Array<ServiceRecordDTO> | null = [];

	drop(log: SelectableServiceLogDTO) {
		log.selected = false
		this.selectedServices = this.selectedServices!.filter(l => l.id !== log.id)
	}

	private selectPayer = false;
	private selectPayee = false;
	private createService = false;

	private setPayer(contact: InvoiceContact) {
		if (this.selectedPayer?.id == contact.id) return;
		this.selectedPayer = contact
		if (contact.id == this.currentProfile.id) {
			if (this.selectedPayee == null) return;
			if (this.selectedPayee.id == this.currentProfile.id) {
				this.selectedPayee = null
			} else {
				this.selectedPayee = this.currentProfile;
			}
		}
		if (this.selectedPayee?.id != this.currentProfile.id) {
			this.selectedPayee = null;
		}
	}
	private setPayee(contact: InvoiceContact) {
		if (this.selectedPayee?.id == contact.id) return;
		this.selectedPayee = contact
		if (contact.id == this.currentProfile.id) {
			if (this.selectedPayer == null) return;
			if (this.selectedPayer.id == this.currentProfile.id) {
				this.selectedPayer = null
			} else {
				this.selectedPayer = this.currentProfile;
			}
		}
		if (this.selectedPayer?.id != this.currentProfile.id) {
			this.selectedPayer = null;
		}
	}

	private selected(arr: Array<ServiceRecordDTO> | null) {
		this.selectedServices = arr
	}

	get dueDayOptions(): SelectOption[] {
		return [
			SelectOption.builder().title("7 days").value(7).build(),
			SelectOption.builder().title("14 days").value(14).build(),
			SelectOption.builder().title("30 days").value(30).build()
		]
	}

	draft() {
		if (this.selectedPayer == null) {
			Notifications.error("Please select a payer")
			return
		}
		if (this.selectedPayee == null) {
			Notifications.error("Please select a payee")
			return
		}
		if (this.selectedServices == null || this.selectedServices.length == 0) {
			Notifications.error("Please select services")
			return;
		}
		if (this.selectedPayee.id == this.selectedPayer.id) {
			Notifications.error("Payee and Payer cannot be the same")
			return
		}
		Application.startLoading()
		this.req.payerId = this.selectedPayer.ref ? this.selectedPayer.ref : this.selectedPayer.id
		this.req.payeeId = this.selectedPayee.ref ? this.selectedPayee.ref : this.selectedPayee.id
		this.req.serviceLogs = this.selectedServices.map(it => it.id)
		ServiceInvoiceOrchestrator.draftInvoice(this.req).then(
			() => {
				Application.stopLoading()
				this.$emit("create")
				this.$emit("input", false)
			},
			err => processError(err, this)
		)
	}

	create() {
		if (this.selectedPayer == null) {
			Notifications.error("Please select a payer")
			return
		}
		if (this.selectedPayee == null) {
			Notifications.error("Please select a payee")
			return
		}
		if (this.selectedServices && this.selectedServices.length == 0) {
			Notifications.error("Please select services")
			return
		}
		if (this.selectedPayee.id == this.selectedPayer.id) {
			Notifications.error("Payee and Payer cannot be the same")
			return
		}
		Application.startLoading()
		this.req.payerId = this.selectedPayer.ref ? this.selectedPayer.ref : this.selectedPayer.id
		this.req.payeeId = this.selectedPayee.ref ? this.selectedPayee.ref : this.selectedPayee.id
		if (this.selectedServices) {
			this.req.serviceLogs = this.selectedServices.map(it => it.id)
		} else {
			this.req.serviceLogs = null
		}
		ServiceInvoiceOrchestrator.createInvoice(this.req).then(
			() => {
				Application.stopLoading()
				this.$emit("create")
				this.$emit("input", false)
			},
			err => processError(err, this)
		)
	}

	get total(): string {
		let total = 0;
		if (this.selectedServices) {
			this.selectedServices.map(it => it.total).forEach(it => total += it)
		}
		return "$" + total.toLocaleString("en-US")
	}

	private openServices() {
		if (!this.selectedPayee) {
			Notifications.error("Please select a payee")
			return
		}
		this.createService = true
	}
}
